import React from "react";

const KeyMetrics = () => {
  return <div>KeyMetrics</div>;
};

export default KeyMetrics;
